import {
  Subscription,
  SubscriptionSource,
  TRIAL_SECONDARY_SOURCE,
} from '../../models';

export const isTrialSubscription = (subscription?: Subscription) => (
  !!subscription
  && subscription.source === SubscriptionSource.TRIAL_REQUEST
  && (
    subscription.subscriptionType === 'TRIAL'
    || (
      !subscription.subscriptionType
      && TRIAL_SECONDARY_SOURCE.includes(subscription.secondarySource)
    )
  )
);
